import { colorConstants } from 'config/colorConstants';
import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const NegativeDownArrow = ({ stroke = colorConstants.red }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.86335 7L9.07514 0.25H0.651566L4.86335 7Z" fill={stroke} />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.86335 7L9.07514 0.25H0.651566L4.86335 7Z" fill={stroke} />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.86335 7L9.07514 0.25H0.651566L4.86335 7Z" fill={stroke} />
        </svg>
    );
};

export default NegativeDownArrow;
